import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
import {Link} from 'shells/link/link';
import {Modal} from 'shells/modal/modal';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import type {GetSessionUser_loggedInUser as User} from 'nutshell-graphql-types';

import {FollowUpTasksOnboardingModalBody} from './follow-up-tasks-onboarding-modal-body';

import styles from './follow-up-tasks-onboarding-modal.module.css';

type Props = {
    isOpen: boolean;
    user: User;
    onClose: () => void;
};

export function FollowUpTasksOnboardingModal(props: Props) {
    const {isOpen, user, onClose} = props;

    return (
        <Modal
            onClose={onClose}
            canClickOutsideToClose={true}
            closeButton={true}
            isOpen={isOpen}
            noPadding={true}
            maxHeight={586}
        >
            <OnboardingPage
                type='singlePage'
                bodyId='follow-up-tasks-onboarding'
                buttonText='Done'
                artImage={<Art />}
                bodyComponent={<FollowUpTasksOnboardingModalBody user={user} />}
                artBackgroundColor={colors.plumXlt}
                onClose={onClose}
                bottomLeftContent={
                    <Link
                        href='https://support.nutshell.com/en/articles/14061539-automatically-create-follow-up-tasks-from-your-calls'
                        newTab={true}
                        size='small'
                        variant='secondary'
                        icon={ExternalLinkIcon}
                    >
                        Learn more
                    </Link>
                }
            />
        </Modal>
    );
}

function Art() {
    return (
        <div className={styles.art}>
            <img src='/include/illustrations/ai-followup-tasks.png' alt='AI follow-up tasks' />
        </div>
    );
}
